//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/ugmath.js";
import "../no/Diagramming.js";
let d=[[[0,"Anchor",1,0],[0,"AnnotationBuilder",1,"Diagramming.CannedAnnotationBuilder",0],[0,"FileToImport",1,0],[0,"LetteringAngle",1,0],[0,"Type",1,0]],[[["locations"],"SetLocations",{},1,0],[["pageObject"],"CreatePrimitiveSheetElement",{R_:{sheetElement:"Diagramming.SheetElement"}},1,0],[["selectedNodes"],"SelectedNodesTag",{},1,0],[["styleName","changedValues","isStyleChanged"],"SetCompareData",{},3,0],[["stringTranslatable"],"SetStringTranslatable",{},1,0]],[]];
SPLM.AME.PrimitiveSheetElementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.PrimitiveSheetElementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.PrimitiveSheetElementBuilder.PrimitiveType = Object.freeze({
    "Line" : "Line", "Circle" : "Circle", "Rectangle" : "Rectangle", "Image" : "Image", "Note" : "Note"});

export default SPLM;